import { Component } from "@angular/core";
import { APP_ROUTES, PERMISSION } from "@app/constants";
import { PermissionService } from "@app/core/auth/permission.service";
import { IVerticalMenuItem, NchlVerticalMenu } from "@nchl/ngx-ui/vertical-menu";

interface VerticalMenuItem extends IVerticalMenuItem {
  permissions?: string[];
  items?: VerticalMenuItem[];
}

@Component({
  selector: "app-sidebar-middle",
  standalone: true,
  imports: [NchlVerticalMenu],
  templateUrl: "./sidebar-middle.component.html",
  styleUrl: "./sidebar-middle.component.css",
})
export class SidebarMiddleComponent {
  menuItems: VerticalMenuItem[] = [];

  constructor(private readonly permissionService: PermissionService) {
    const allMenuItems = this.getAllAppMenuItems();
    let permittedMenuItems: VerticalMenuItem[];
    permittedMenuItems = this.getPermittedMenuItems(allMenuItems);
    this.menuItems = permittedMenuItems;
  }

  getAllAppMenuItems(): VerticalMenuItem[] {
    return [
      {
        label: "Dashboard",
        items: [
          {
            label: "Dashboard",
            icon: "nchlHome",
            routerLink: [APP_ROUTES.ROOT, APP_ROUTES.DASHBOARD],
            permissions: [PERMISSION.DASHBOARD_VIEW],
          },
        ],
      },
      {
        label: "Menu",
        permissions: [
          PERMISSION.DASHBOARD_VIEW,
          // PERMISSION.DEBIT_ALL_CARD_LIST,
          PERMISSION.DEBIT_PENDING_LIST,
          // PERMISSION.CARD_DETAIL_VIEW,

          // COMMENTED Whole "Menu" for now (Only putting at least 1 works !!!! - 2 kept)
          // PERMISSION.DEBIT_APPROVE,
          // // PERMISSION.CARD_REJECT,
          // // PERMISSION.CARD_DELETE,
          // PERMISSION.DEBIT_CREATE,
          // // PERMISSION.CARD_CREATE_BULK,
          // PERMISSION.DEBIT_LIST_FOR_SEND_TO_SWITCH,
          // PERMISSION.DEBIT_SEND_TO_SWITCH,
          // // PERMISSION.CARD_SEND_TO_SWITCH_ACCEPT,
          // // PERMISSION.CARD_SEND_TO_SWITCH_DELETE, TODO: WIP
          // PERMISSION.DEBIT_LIST_FOR_CARD_MAPPING,
          // // PERMISSION.CARD_MAPPING_ACCEPT,
          // PERMISSION.DEBIT_CARD_MAPPING_BULK,
          // PERMISSION.DEBIT_LIST_FOR_CARD_DISPATCH,
          // // PERMISSION.CARD_DISPATCH_APPROVE,
          // PERMISSION.DEBIT_LIST_FOR_CARD_DISPATCH,
          // // PERMISSION.CARD_PIN_DISPATCH_LIST,
          // PERMISSION.DEBIT_CARD_DISPATCH,
          // // PERMISSION.CARD_PIN_DISPATCH_APPROVE,
          // PERMISSION.DEBIT_LIST_FOR_CARD_ACK,
          // PERMISSION.DEBIT_CARD_ACK,
          // // PERMISSION.CARD_ACKNOWLEDGE_ACCEPT,
          // // PERMISSION.CARD_DELIVERY_ACCEPT,
          // PERMISSION.DEBIT_LIST_FOR_PIN_ACK,
          // PERMISSION.DEBIT_PIN_ACK,
          // PERMISSION.DEBIT_LIST_FOR_CARD_DELIVERY,
          // PERMISSION.DEBIT_CARD_DELIVERY,
          // // PERMISSION.PIN_ACKNOWLEDGE_ACCEPT,
          // PERMISSION.DEBIT_LIST_FOR_PIN_DELIVERY,
          // PERMISSION.DEBIT_PIN_DELIVERY,
          // // PERMISSION.PIN_DELIVERY_ACCEPT,
          // // PERMISSION.CARD_ACTIVATION_LIST,
          // // PERMISSION.CARD_ACTIVATION_ACCEPT,
          // // PERMISSION.CARD_REPROCESS_PENDING_VIEW,
          // // PERMISSION.CARD_FORWARD_PENDING_VIEW,
          // PERMISSION.DEBIT_LIST_FOR_CARD_ACTIVATION,
          // PERMISSION.DEBIT_CARD_ACTIVATION,

          // // PERMISSION.CREDIT_CARD_LIST_VIEW,
          // PERMISSION.NOTICE_LIST,
          // PERMISSION.NOTICE_CREATE,
          // PERMISSION.NOTICE_UPDATE_DELETE,
          // // PERMISSION.CONFIG_NOTICE_DELETE,
          // // PERMISSION.CONFIG_NOTICE_PAGE,
          // // PERMISSION.CONFIG_NOTICE_GET,

          // PERMISSION.ACC_TYPE_LIST,
          // PERMISSION.ACC_TYPE_CREATE,
          // // PERMISSION.CONFIG_ACCOUNT_TYPE_CREATE,
          // PERMISSION.ACC_TYPE_UPDATE,
          // // PERMISSION.CONFIG_ACCOUNT_TYPE_UPDATE,
          // // PERMISSION.CONFIG_ACCOUNT_TYPE_DELETE,
          // // PERMISSION.CONFIG_ACCOUNT_TYPE_GET,
          // PERMISSION.PRODUCT_TYPE_CREATE,
          // // PERMISSION.CONFIG_PRODUCT_TYPE_BULK_UPLOAD,
          // PERMISSION.PRODUCT_TYPE_LIST,
          // PERMISSION.PRODUCT_TYPE_UPDATE,
          // // PERMISSION.CONFIG_PRODUCT_TYPE_DELETE,
          // // PERMISSION.CONFIG_PRODUCT_TYPE_BLOCK_UNBLOCK,
          // // PERMISSION.CONFIG_PRODUCT_TYPE_PAGE,
          // PERMISSION.WVR_CREATE,
          // // PERMISSION.CONFIG_WAIVER_BULK_UPLOAD,
          // PERMISSION.WVR_LIST,
          // PERMISSION.WVR_UPDATE,
          // // PERMISSION.CONFIG_WAIVER_DELETE,
          // PERMISSION.WVR_LIST,
          // PERMISSION.BRANCH_CREATE,
          // // PERMISSION.BRANCH_BULK_UPLOAD,
          // PERMISSION.BRANCH_LIST,
          // // PERMISSION.BRANCH_UPDATE,
          // // PERMISSION.BRANCH_DELETE,
          // // PERMISSION.BRANCH_BLOCK_UNBLOCK,
          // // PERMISSION.BRANCH_PAGE,
          // PERMISSION.CONFIG_MEMBER_BANK_CREATE,
          // PERMISSION.CONFIG_MEMBER_BANK_BULK_UPLOAD,
          // PERMISSION.CONFIG_MEMBER_BANK_GET,
          // PERMISSION.CONFIG_MEMBER_BANK_UPDATE,
          // PERMISSION.CONFIG_MEMBER_BANK_DELETE,
          // PERMISSION.CONFIG_MEMBER_BANK_BLOCK_UNBLOCK,
          // PERMISSION.CONFIG_MEMBER_BANK_PAGE,
          // PERMISSION.SERVICE_TYPE_CREATE,
          // PERMISSION.SERVICE_TYPE_UPDATE,
          // // PERMISSION.CONFIG_SERVICE_TYPE_DELETE,
          // PERMISSION.SERVICE_TYPE_LIST,
          // // PERMISSION.CONFIG_SERVICE_TYPE_GET,
          // PERMISSION.USR_CREATE,
          // // PERMISSION.SYSTEM_USER_BULK_UPLOAD,
          // PERMISSION.USR_LIST,
          // PERMISSION.USR_UPDATE,
          // // PERMISSION.SYSTEM_USER_DELETE,
          // // PERMISSION.SYSTEM_USER_BLOCK_UNBLOCK,
          // // PERMISSION.SYSTEM_USER_PAGE,
          // // PERMISSION.SYSTEM_USER_CHANGE_PASSWORD,
          // // PERMISSION.SYSTEM_USER_RESET_PASSWORD,
          // // PERMISSION.SYSTEM_USER_PROFILE,
          // PERMISSION.ROLE_CREATE,
          // // PERMISSION.SYSTEM_ROLE_BULK_UPLOAD,
          // PERMISSION.ROLE_LIST,
          // PERMISSION.ROLE_UPDATE,
          // // PERMISSION.SYSTEM_ROLE_DELETE,
          // // PERMISSION.SYSTEM_ROLE_BLOCK_UNBLOCK,
          // // PERMISSION.SYSTEM_ROLE_PAGE,

          // PERMISSION.PERMISSION_LIST,
          // PERMISSION.PAYOPT_CREATE,
          // // PERMISSION.PAYMENT_OPTION_CREATE_BULK,
          // PERMISSION.PAYOPT_LIST,
          // PERMISSION.PAYOPT_UPDATE,
          // // PERMISSION.PAYMENT_OPTION_PAGE,
          // // PERMISSION.PAYMENT_OPTION_DELETE,
          // // PERMISSION.PAYMENT_OPTION_BLOCK,
          // // PERMISSION.PAYMENT_OPTION_UNBLOCK,
          // PERMISSION.FEEPR_CREATE,
          // // PERMISSION.FEE_PROFILE_CREATE_BULK,
          // PERMISSION.FEEPR_LIST,
          // PERMISSION.FEEPR_UPDATE,
          // // PERMISSION.FEE_PROFILE_PAGE,
          // // PERMISSION.FEE_PROFILE_DELETE,
          // // PERMISSION.FEE_PROFILE_BLOCK,
          // // PERMISSION.FEE_PROFILE_UNBLOCK,
          // // PERMISSION.FEE_PROFILE_VIEW,
          // // PERMISSION.FEE_PROFILE_LIST_VIEW,
          // // PERMISSION.FEE_PROFILE_BLOCK_UNBLOCK,
          // PERMISSION.BLKUNBLK_VIEW,
          // PERMISSION.BLKUNBLK_CREATE,
          // PERMISSION.BLKUNBLK_UPDATE,
          // // PERMISSION.CARD_BLOCK_REJECT,
          // // PERMISSION.CARD_BLOCK_DELETE,

          // // PERMISSION.CARD_EXPIRE_LIST_VIEW,
          // PERMISSION.RENEW_VIEW,
          // PERMISSION.RENEW_CREATE,
          // PERMISSION.RENEW_APPROVE_REJECT,
          // PERMISSION.REPLACE_VIEW,
          // PERMISSION.REPLACE_CREATE,
          // PERMISSION.REPLACE_APPROVE_REJECT,
          // PERMISSION.REPIN_LIST,
          // PERMISSION.REPIN_CREATE,
          // PERMISSION.REPIN_UPDATE,
          // // PERMISSION.CARD_REPIN_DELETE,
          // PERMISSION.REPIN_SEND_TO_SWITCH,
          // PERMISSION.REPIN_ACKNOWLEDGE,
          // PERMISSION.REPIN_DELIVER,
          // // PERMISSION.CARD_REPIN_ACTIVATE, //TODO (BACKEND not ready)
          // PERMISSION.CARD_UNBLOCK_LIST_VIEW,
          // PERMISSION.CARD_UNBLOCK_CREATE,
          // PERMISSION.CARD_UNBLOCK_ACCEPT,
          // PERMISSION.CARD_UNBLOCK_REJECT,
          // PERMISSION.CARD_UNBLOCK_DELETE,
          // PERMISSION.CUSTOMER_CARD_BLOCK,
          // PERMISSION.CUSTOMER_CARD_UNBLOCK,
          // PERMISSION.CUSTOMER_CARD_REPLACE,
          // PERMISSION.CUSTOMER_CARD_REPIN,
          // PERMISSION.INSTANT_CARD_LIST_VIEW,
          // PERMISSION.INSTANT_CARD_ASSIGN_PENDING_LIST_FOR_BRANCH_ASSIGN,
          // PERMISSION.INSTANT_CARD_ASSIGN_APPROVE_LIST_FOR_ACKNOWLEDGE,
          // PERMISSION.INSTANT_CARD_ACKNOWLEDGE_LIST_FOR_ACCOUNT_LINK,
          // PERMISSION.INSTANT_CARD_LINK_PENDING_LIST_FOR_LINK_APPROVAL,
          // PERMISSION.INSTANT_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
          // PERMISSION.INSTANT_CARD_LINK_REJECT_LIST,
          // PERMISSION.INSTANT_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
          // PERMISSION.INSTANT_CARD_LINK_ACTIVATED_LIST,
          // PERMISSION.INSTANT_CARD_CREATE_BTRT,
          // PERMISSION.INSTANT_CARD_CREATE_BULK,
          // PERMISSION.INSTANT_CARD_ASSIGN_BRANCH,
          // PERMISSION.INSTANT_CARD_ACKNOWLEDGE,
          // PERMISSION.INSTANT_CARD_LINK_ACCOUNT,
          // PERMISSION.INSTANT_CARD_LINK_APPROVE,
          // PERMISSION.INSTANT_CARD_LINK_REJECT,
          // PERMISSION.INSTANT_CARD_DELETE,
          // PERMISSION.INSTANT_CARD_LINK_ACTIVATE,
          // PERMISSION.INSTANT_CARD_ACTIVATE,

          // // PREPAID:
          // PERMISSION.PREPAID_ALL_CARD_LIST,
          // PERMISSION.PREPAID_BRANCH_ASSIGN_PENDING_LIST,
          // PERMISSION.PREPAID_LIST_FOR_CARD_ACK,
          // PERMISSION.PREPAID_LIST_FOR_LINK_CARD_VERIFY,
          // // PERMISSION.PREPAID_CARD_LINK_PENDING_LIST_LINK_APPROVAL,
          // // PERMISSION.PREPAID_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
          // // PERMISSION.PREPAID_CARD_LINK_REJECT_LIST,
          // // PERMISSION.PREPAID_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
          // // PERMISSION.PREPAID_CARD_LINK_ACTIVATED_LIST,
          // // PERMISSION.PREPAID_CARD_CREATE_BTRT,
          // // PERMISSION.PREPAID_CARD_CREATE_BULK,
          // // PERMISSION.PREPAID_CARD_ASSIGN_BRANCH,
          // // PERMISSION.PREPAID_CARD_ACKNOWLEDGE,
          // // PERMISSION.PREPAID_CARD_LINK_ACCOUNT,
          // // PERMISSION.PREPAID_CARD_LINK_APPROVE,
          // // PERMISSION.PREPAID_CARD_LINK_REJECT,
          // // PERMISSION.PREPAID_CARD_DELETE,
          // // PERMISSION.PREPAID_CARD_LINK_ACTIVATE,
          // // PERMISSION.PREPAID_CARD_ACTIVATE,
          // PERMISSION.CARD_RENEW_FOLLOW_UP,
          // PERMISSION.CHARGE_PROFILE_CREATE,
          // PERMISSION.CHARGE_PROFILE_LIST,
          // // PERMISSION.CHARGE_PROFILE_PAGE,
          // // PERMISSION.CHARGE_PROFILE_FILTER,
          // // PERMISSION.CHARGE_PROFILE_LIST,
          // PERMISSION.CHARGE_PROFILE_UPDATE,
          // // PERMISSION.CHARGE_PROFILE_DELETE,
          // PERMISSION.DASHBOARD_SUMMARY,
          // // PERMISSION.NOTICE_PAGE,
          // PERMISSION.NOTICE_LIST,
          // PERMISSION.NOTICE_PAGE_MARK_AS_READ,
          // PERMISSION.NOTICE_SPLASH,

          // // CREDIT_CARDS
          // PERMISSION.CREDIT_PENDING_LIST,
          // PERMISSION.CREDIT_DOC_VERIFICATION_LIST,
          // PERMISSION.CREDIT_DOC_VERIFICATION_APPROVAL_LIST,
          // PERMISSION.CREDIT_LIST_FOR_SEND_SWITCH,
          // PERMISSION.CREDIT_LIST_FOR_MAPPING,
          // PERMISSION.CREDIT_LIST_FOR_CARD_DISPATCH,
          // PERMISSION.CREDIT_LIST_FOR_PIN_DISPATCH,
          // PERMISSION.CREDIT_LIST_FOR_CARD_ACK,
          // PERMISSION.CREDIT_LIST_FOR_PIN_ACK,
          // PERMISSION.CREDIT_LIST_FOR_CARD_DELIVERY,
          // PERMISSION.CREDIT_LIST_FOR_PIN_DELIVERY,
          // PERMISSION.CREDIT_LIST_FOR_CARD_ACTIVATION,
          // PERMISSION.CREDIT_CREATE,
          // PERMISSION.CREDIT_APPROVE, //CREDIT_CARD_VERIFY
          // PERMISSION.CREDIT_DOC_VERIFY,
          // PERMISSION.CREDIT_DOC_VERIFY_APPROVE,
          // PERMISSION.CREDIT_SEND_TO_SWITCH,
          // PERMISSION.CREDIT_CARD_MAPPING,
          // PERMISSION.CREDIT_CARD_DISPATCH,
          // PERMISSION.CREDIT_PIN_DISPATCH,
          // PERMISSION.CREDIT_CARD_ACK,
          // PERMISSION.CREDIT_PIN_ACK,
          // PERMISSION.CREDIT_CARD_DELIVERY,
          // PERMISSION.CREDIT_PIN_DELIVERY,
          // PERMISSION.CREDIT_CARD_ACTIVATION,

          // PERMISSION.ACCOUNT_SETTING_LIST,
          // PERMISSION.ACCOUNT_SETTING_CREATE,
          // PERMISSION.ACCOUNT_SETTING_UPDATE,
          // PERMISSION.ACTIVATION_API_SETTING_LIST,
          // PERMISSION.ACTIVATION_API_SETTING_CREATE,
          // PERMISSION.ACTIVATION_API_SETTING_UPDATE,
          // PERMISSION.ATTACHMENT_SETTING_CREATE,
          // PERMISSION.CALL_CENTER_SETTING_CREATE,
          // PERMISSION.RECONCILIATION_SETTING_CREATE,
          // PERMISSION.CARD_SETTING_CREATE,
          // PERMISSION.CARD_SETTING_LIST,
          // PERMISSION.CARD_SETTING_UPDATE,
          // PERMISSION.GENERAL_SETTING_LIST,
          // PERMISSION.GENERAL_SETTING_CREATE,
          // PERMISSION.GENERAL_SETTING_UPDATE,
          // PERMISSION.GENERAL_SETTING_BY_BANK_CODE,
          // PERMISSION.GENERAL_SETTING_LIST_CONSTANT,
          // PERMISSION.TXN_SETTING_LIST,
          // PERMISSION.TXN_SETTING_CREATE,
          // PERMISSION.TXN_SETTING_UPDATE,
          // PERMISSION.SCHEDULER_START,
          // PERMISSION.SCHEDULER_STOP,
          // PERMISSION.SCHEDULER_STATUS,
          // PERMISSION.SCHEDULER_JOB_CREATE,
          // PERMISSION.SCHEDULER_JOBS_LIST,
          // PERMISSION.SCHEDULER_JOB_BY_UNIQUE_ID,
          // PERMISSION.SCHEDULER_UPDATE_JOB,
          // PERMISSION.CARD_REPROCESS_LIST_VIEW,
          // PERMISSION.CARD_FORWARD_LIST_VIEW,
          // // PERMISSION.CONFIG_BRANCH_PAGE,
          // // PERMISSION.CONFIG_ACCOUNT_TYPE_PAGE,
          // // PERMISSION.CONFIG_PRODUCT_TYPE_PAGE,
          // // PERMISSION.CHARGE_PROFILE_PAGE,
          // // PERMISSION.PAYMENT_OPTION_PAGE,
          // // PERMISSION.FEE_PROFILE_PAGE,
          // // PERMISSION.CONFIG_WAIVER_PAGE,
          // // PERMISSION.CONFIG_NOTICE_PAGE,
          // //
          // // PERMISSION.CARD_PENDING_VIEW,
          // // PERMISSION.CARD_SEND_TO_SWITCH_LIST,
          // //
          // // PERMISSION.INSTANT_CARD_LIST_VIEW,
          // // PERMISSION.INSTANT_CARD_ASSIGN_PENDING_LIST_FOR_BRANCH_ASSIGN,
          // // PERMISSION.INSTANT_CARD_ASSIGN_APPROVE_LIST_FOR_ACKNOWLEDGE,
          // // PERMISSION.INSTANT_CARD_ACKNOWLEDGE_LIST_FOR_ACCOUNT_LINK,
          // // PERMISSION.INSTANT_CARD_LINK_PENDING_LIST_FOR_LINK_APPROVAL,
          // // PERMISSION.INSTANT_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
          // // PERMISSION.INSTANT_CARD_LINK_REJECT_LIST,
          // // PERMISSION.INSTANT_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
          // // PERMISSION.INSTANT_CARD_LINK_ACTIVATED_LIST,
          // //
          // // PERMISSION.PREPAID_CARD_LIST_VIEW,
          // // PERMISSION.PREPAID_CARD_ASSIGN_PENDING_LIST_FOR_BRANCH_ASSIGN,
          // // PERMISSION.PREPAID_CARD_ASSIGN_APPROVE_LIST_FOR_ACKNOWLEDGE,
          // // PERMISSION.PREPAID_CARD_ACKNOWLEDGE_LIST_FOR_ACCOUNT_LINK,
          // // PERMISSION.PREPAID_CARD_LINK_PENDING_LIST_LINK_APPROVAL,
          // // PERMISSION.PREPAID_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
          // // PERMISSION.PREPAID_CARD_LINK_REJECT_LIST,
          // // PERMISSION.PREPAID_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
          // // PERMISSION.PREPAID_CARD_LINK_ACTIVATED_LIST,
          // //
          // // PERMISSION.CARD_EXPIRE_LIST_VIEW,
          // // PERMISSION.CARD_RENEW_LIST_VIEW,
          // //
          // // PERMISSION.CARD_REPLACE_LIST_VIEW,
          // //
          // // PERMISSION.CARD_BLOCK_LIST_VIEW,
          // // PERMISSION.CARD_UNBLOCK_LIST_VIEW,
          // //
          // // PERMISSION.CARD_REPROCESS_PENDING_VIEW,
          // //
          // // PERMISSION.CARD_BLOCK_LIST_VIEW,
          // // PERMISSION.CARD_UNBLOCK_LIST_VIEW,
          // //
          // // PERMISSION.CARD_REPIN_LIST_VIEW,
          // // PERMISSION.CARD_REPIN_SEND_TO_SWITCH,
          // // PERMISSION.CARD_REPIN_ACKNOWLEDGE,
          // // PERMISSION.CARD_REPIN_DELIVER,
          // // PERMISSION.CARD_REPIN_ACTIVATE,
        ],
        items: [
          {
            label: "Configuration",
            icon: "lucideSettings",
            permissions: [
              PERMISSION.BRANCH_LIST,
              PERMISSION.ACC_TYPE_LIST,
              PERMISSION.PRODUCT_TYPE_LIST,
              PERMISSION.SERVICE_TYPE_LIST,
              PERMISSION.CHARGE_PROFILE_LIST,
              PERMISSION.PAYOPT_LIST,
              PERMISSION.FEEPR_LIST,
              PERMISSION.WVR_LIST,
              PERMISSION.NOTICE_LIST,
            ],

            items: [
              {
                label: "Settings",
                icon: "lucideSettings",
                permissions: [ PERMISSION.SETTING,],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.SETTINGS,
                ],
              },
              {
                label: "Branch",
                icon: "lucideBuilding",
                permissions: [PERMISSION.BRANCH_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.BRANCH,
                ],
              },
              {
                label: "Account Type",
                icon: "lucideFileText",
                permissions: [PERMISSION.ACC_TYPE_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.ACCOUNT_TYPE,
                ],
              },
              {
                label: "Product Type",
                icon: "lucidePackage",
                permissions: [PERMISSION.PRODUCT_TYPE_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.PRODUCT_TYPE,
                ],
              },
              {
                label: "Service Type",
                icon: "lucideWrench",
                permissions: [PERMISSION.SERVICE_TYPE_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.SERVICE_TYPE,
                ],
              },
              {
                label: "Charge Profile",
                icon: "lucideBadgeDollarSign",
                permissions: [PERMISSION.CHARGE_PROFILE_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.CHARGE,
                  // APP_ROUTES.PIN,
                  // APP_ROUTES.SYSTEM_USER,
                ],
              },

              {
                label: "Payment Option",
                icon: "lucideBanknote",
                permissions: [PERMISSION.PAYOPT_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.PAYMENT_OPTION,
                ],
              },
              {
                label: "Fee Profile",
                icon: "lucidePercent",
                permissions: [PERMISSION.FEEPR_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.FEE_PROFILE,
                ],
              },
              {
                label: "Waiver List",
                icon: "lucideFileMinus",
                permissions: [PERMISSION.WVR_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.WAIVER,
                ],
              },
              {
                label: "Notice",
                icon: "lucideBell",
                permissions: [PERMISSION.NOTICE_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.NOTICE,
                ],
              },
              // {
              //   label: 'Task Scheduler',
              //   icon: '',
              //   //permissions: [PERMISSION.SYSTEM_USER_VIEW],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.CONFIGURATION,
              //     APP_ROUTES.TASK_SCHEDULER,
              //   ],
              // }
              // {
              //   label: 'SMS',
              //   icon: '',
              //   // permissions: [PERMISSION.SYSTEM_USER_VIEW],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.CONFIGURATION,
              //     APP_ROUTES.SMS,
              //   ],
              // }
              /*,
              {
                label: 'Group',
                icon: '',
                // permissions: [PERMISSION.SYSTEM_USER_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.GROUP,
                ],
              }*/
              /* {
                   label: 'Welcome Letter',
                   icon: '',
                   // permissions: [PERMISSION.SYSTEM_USER_VIEW],
                   routerLink: [
                     APP_ROUTES.ROOT,
                     APP_ROUTES.CONFIGURATION,
                     APP_ROUTES.WELCOME_LETTER,
                   ],
                 },*/
              /*{
                label: 'Member Banks',
                icon: '',
                //permissions: [PERMISSION.SYSTEM_USER_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.MEMBER_BANK,
                ],
              }*/
             {
                label: "Notifications Management",
                icon: "lucideBell",
                permissions: [PERMISSION.NOTIFICATION_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.NOTIFICATIONS,
                ],
              },
             {
                label: "Letter Management",
                icon: "lucideFileText",
                permissions: [
                  PERMISSION.LETTER_VIEW,
                ],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CONFIGURATION,
                  APP_ROUTES.LETTER,
                ],
              },
            ],
          },

          /*{
            label: 'Branch',
            icon: 'pi pi-building-columns',
            items: [
              {
                label: 'List',
                icon: '',
                permissions: [PERMISSION.CONFIG_BRANCH_PAGE],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.BRANCH
                ],
              }
            ]
          },*/

          {
            label: "Debit Cards",
            icon: "lucideCreditCard",
            permissions: [
              PERMISSION.DEBIT_PENDING_LIST,
              PERMISSION.DEBIT_LIST_FOR_SEND_TO_SWITCH,
              PERMISSION.DEBIT_LIST_FOR_CARD_MAPPING,
              PERMISSION.DEBIT_LIST_FOR_CARD_DISPATCH,
              PERMISSION.DEBIT_LIST_FOR_PIN_DISPATCH,
              PERMISSION.DEBIT_LIST_FOR_CARD_ACK,
              //PERMISSION.CARD_LIST_VIEW
            ],
            items: [
              /*  {
                  label: 'Card Management',
                  items: [

                  ],
                },*/
              {
                label: "Card Entry",
                icon: "lucideFileInput",
                permissions: [PERMISSION.DEBIT_PENDING_LIST],
                routerLink: [APP_ROUTES.ROOT, APP_ROUTES.CARD],
              },
              {
                label: "Send to Switch",
                icon: "lucideSend",
                permissions: [PERMISSION.DEBIT_LIST_FOR_SEND_TO_SWITCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.CARD_SEND_TO_SWITCH,
                ],
              },
              {
                label: "Card Mapping",
                icon: "lucideArrowRightLeft",
                permissions: [PERMISSION.DEBIT_LIST_FOR_CARD_MAPPING],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.CARD_MAPPING,
                ],
              },
              {
                label: "Card Dispatch",
                icon: "lucideTruck",
                permissions: [PERMISSION.DEBIT_LIST_FOR_CARD_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.CARD_DISPATCH,
                ],
              },
              {
                label: "Pin Dispatch",
                icon: "lucideMail",
                permissions: [PERMISSION.DEBIT_LIST_FOR_PIN_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.PIN_DISPATCH,
                ],
              },
              {
                label: "Card Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.DEBIT_LIST_FOR_CARD_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.CARD_ACKNOWLEDGE,
                ],
              },
              {
                label: "Pin Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.DEBIT_LIST_FOR_PIN_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PIN,
                  APP_ROUTES.PIN_ACKNOWLEDGE,
                ],
              },
              {
                label: "Card Delivery",
                icon: "lucideUserCheck",
                permissions: [PERMISSION.DEBIT_LIST_FOR_CARD_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.CARD_DELIVERY,
                ],
              },
              {
                label: "Pin Delivery",
                icon: "lucideUserCheck",
                permissions: [PERMISSION.DEBIT_LIST_FOR_PIN_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PIN,
                  APP_ROUTES.PIN_DELIVERY,
                ],
              },
              {
                label: "Activation",
                icon: "lucidePower",
                permissions: [PERMISSION.DEBIT_LIST_FOR_CARD_ACTIVATION],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.CARD_ACTIVATION,
                ],
              },
            ],
          },

          {
            label: "Credit Cards",
            icon: "lucideCreditCard",
            permissions: [
              PERMISSION.CREDIT_ALL_CARD_LIST,
              PERMISSION.CREDIT_DOC_VERIFICATION_LIST,
              PERMISSION.CREDIT_DOC_VERIFICATION_APPROVAL_LIST,
              PERMISSION.CREDIT_LIST_FOR_SEND_SWITCH,
              PERMISSION.CREDIT_LIST_FOR_MAPPING,
              PERMISSION.CREDIT_LIST_FOR_CARD_DISPATCH,
              PERMISSION.CREDIT_LIST_FOR_PIN_DISPATCH,
              PERMISSION.CREDIT_LIST_FOR_CARD_ACK,
              PERMISSION.CREDIT_LIST_FOR_PIN_ACK,
              PERMISSION.CREDIT_LIST_FOR_CARD_DELIVERY,
              PERMISSION.CREDIT_LIST_FOR_PIN_DELIVERY,
              PERMISSION.CREDIT_LIST_FOR_CARD_ACTIVATION,
              PERMISSION.CREDIT_CARD_MAPPING,
              PERMISSION.CREDIT_LIST_FOR_MAPPING,
            ],
            items: [
              {
                label: "Card Entry",
                icon: "lucideFileInput",
                permissions: [PERMISSION.CREDIT_PENDING_LIST],
                routerLink: [APP_ROUTES.ROOT, APP_ROUTES.CREDIT_CARDS],
              },
              {
                label: "Verify Documents",
                icon: "lucideFileCheck",
                permissions: [PERMISSION.CREDIT_DOC_VERIFICATION_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.VERIFY_DOCUMENTS,
                ],
              },
              {
                label: "Pending Approvals",
                icon: "lucideClock",
                permissions: [PERMISSION.CREDIT_DOC_VERIFICATION_APPROVAL_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.PENDING_APPROVAL,
                ],
              },
              {
                label: "Send to Switch",
                icon: "lucideSend",
                permissions: [PERMISSION.CREDIT_LIST_FOR_SEND_SWITCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.CARD_SEND_TO_SWITCH,
                ],
              },
              {
                label: "Card Mapping",
                icon: "lucideArrowRightLeft",
                permissions: [PERMISSION.CREDIT_LIST_FOR_MAPPING],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.CARD_MAPPING,
                ],
              },

              {
                label: "Card Dispatch",
                icon: "lucideTruck",
                permissions: [PERMISSION.CREDIT_LIST_FOR_CARD_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.CARD_DISPATCH,
                ],
              },
              {
                label: "Pin Dispatch",
                icon: "lucideMail",
                permissions: [PERMISSION.CREDIT_LIST_FOR_PIN_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.PIN_DISPATCH,
                ],
              },
              {
                label: "Card Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.CREDIT_LIST_FOR_CARD_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.CARD_ACKNOWLEDGE,
                ],
              },
              {
                label: "Pin Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.CREDIT_LIST_FOR_PIN_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.PIN,
                  APP_ROUTES.PIN_ACKNOWLEDGE,
                ],
              },
              {
                label: "Card Delivery",
                icon: "lucideUserCheck",
                permissions: [PERMISSION.CREDIT_LIST_FOR_CARD_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.CARD_DELIVERY,
                ],
              },
              {
                label: "Pin Delivery",
                icon: "lucideUserCheck",
                permissions: [PERMISSION.CREDIT_LIST_FOR_PIN_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.PIN,
                  APP_ROUTES.PIN_DELIVERY,
                ],
              },
              {
                label: "Activation",
                icon: "lucidePower",
                permissions: [PERMISSION.CREDIT_LIST_FOR_CARD_ACTIVATION],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CREDIT_CARDS,
                  APP_ROUTES.CARD_ACTIVATION,
                ],
              },
            ],
          },

          {
            label: "Instant Cards",
            icon: "lucideCreditCard",
            permissions: [
              PERMISSION.INSTANT_ALL_CARD_LIST,
              // PERMISSION.INSTANT_CARD_ASSIGN_PENDING_LIST_FOR_BRANCH_ASSIGN,
              // PERMISSION.INSTANT_CARD_ASSIGN_APPROVE_LIST_FOR_ACKNOWLEDGE,
              // PERMISSION.INSTANT_CARD_ACKNOWLEDGE_LIST_FOR_ACCOUNT_LINK,
              // PERMISSION.INSTANT_CARD_LINK_PENDING_LIST_FOR_LINK_APPROVAL,
              // PERMISSION.INSTANT_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
              // PERMISSION.INSTANT_CARD_LINK_REJECT_LIST,
              // PERMISSION.INSTANT_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
              // PERMISSION.INSTANT_CARD_LINK_ACTIVATED_LIST,
            ],
            items: [
              {
                label: "Card Request",
                icon: "lucideSend",
                permissions: [PERMISSION.CRDREQ_HEADOFFICE_REQUEST_TO_SWITCH],
                routerLink: [APP_ROUTES.ROOT, APP_ROUTES.INSTANT],
              },
              {
                label: "Assign Branch",
                icon: "lucideShare2",
                permissions: [PERMISSION.INSTANT_BRANCH_ASSIGN_PENDING_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.ASSIGN,
                ],
              },
              {
                label: "Card Dispatch",
                icon: "lucideSend",
                permissions: [PERMISSION.INSTANT_LIST_FOR_CARD_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.DISPATCH,
                ],
              },
              {
                label: "PIN Dispatch",
                icon: "lucideSend",
                permissions: [PERMISSION.INSTANT_LIST_FOR_PIN_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.PIN_DISPATCH,
                ],
              },
              {
                label: "Card Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [
                  // PERMISSION.INSTANT_CARD_ASSIGN_APPROVE_LIST_FOR_ACKNOWLEDGE,
                  PERMISSION.INSTANT_LIST_FOR_CARD_ACK,
                ],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.CARD_ACKNOWLEDGE,
                ],
              },
              {
                label: "Pin Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.INSTANT_LIST_FOR_PIN_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.PIN_ACKNOWLEDGE,
                ],
              },
              {
                label: "Link Card",
                icon: "lucideLink",
                permissions: [PERMISSION.INSTANT_LIST_FOR_LINKING_CARD],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.LINK,
                ],
              },
              {
                label: "Verify Linked Cards",
                icon: "nchlCheck",
                permissions: [PERMISSION.INSTANT_LIST_FOR_LINK_CARD_VERIFY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.VERIFY,
                ],
              },
              {
                label: "Activate Linked Cards",
                icon: "nchlKey",
                permissions: [
                  // PERMISSION.INSTANT_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
                  PERMISSION.INSTANT_LIST_FOR_SEND_TO_SWITCH,
                ],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.ACTIVATE_LINKED_ACCOUNT,
                ],
              },
              {
                label: "Card Mapping",
                icon: "lucideArrowRightLeft",
                permissions: [
                  // PERMISSION.INSTANT_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
                  PERMISSION.INSTANT_LIST_FOR_CARD_MAPPING,
                ],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.CARD_MAPPING,
                ],
              },
              {
                label: "Card Delivery",
                icon: 'nchlKey',
                permissions: [PERMISSION.INSTANT_LIST_FOR_CARD_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.CARD_DELIVERY,
                ],
              },
              {
                label: "Pin Delivery",
                icon: 'nchlKey',
                permissions: [PERMISSION.INSTANT_LIST_FOR_PIN_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.PIN_DELIVERY,
                ],
              },
              {
                label: "Activation",
                icon: "nchlCheckCircle",
                permissions: [PERMISSION.INSTANT_LIST_FOR_CARD_ACTIVATION],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.INSTANT,
                  APP_ROUTES.INSTANT_CARDS.ACTIVATE,
                ],
              },
            ],
          },
          {
            label: "Prepaid Cards",
            icon: "lucideCreditCard",
            permissions: [
              PERMISSION.PREPAID_ALL_CARD_LIST,
              // PERMISSION.PREPAID_BRANCH_ASSIGN_PENDING_LIST,
              // PERMISSION.PREPAID_BRANCH_ASSIGN_PENDING_LIST,
              // PERMISSION.PREPAID_LIST_FOR_CARD_ACK,
              // PERMISSION.PREPAID_LIST_FOR_CARD_DISPATCH,
              // PERMISSION.PREPAID_LIST_FOR_PIN_DISPATCH,

              // PERMISSION.PREPAID_LIST_FOR_CARD_ACK,
              // PERMISSION.PREPAID_LIST_FOR_PIN_ACK,
              // PERMISSION.PREPAID_LIST_FOR_LINKING_CARD,
              // PERMISSION.PREPAID_LIST_FOR_LINK_CARD_VERIFY,
              // PERMISSION.PREPAID_LIST_FOR_SEND_TO_SWITCH,
              // PERMISSION.PREPAID_LIST_FOR_CARD_DELIVERY,
              // PERMISSION.PREPAID_LIST_FOR_PIN_DELIVERY,
              // PERMISSION.PREPAID_LIST_FOR_CARD_ACTIVATION,

              // ///////////below this is old Perms
              // PERMISSION.PREPAID_CARD_ACKNOWLEDGE_LIST_FOR_ACCOUNT_LINK,
              // PERMISSION.PREPAID_,
              // PERMISSION.PREPAID_CARD_LINK_APPROVE_LIST_FOR_LINK_ACCOUNT_ACTIVATION,
              // PERMISSION.PREPAID_CARD_LINK_REJECT_LIST,
              // PERMISSION.PREPAID_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
              // PERMISSION.PREPAID_CARD_LINK_ACTIVATED_LIST,
            ],
            items: [
              {
                label: "Card Request",
                icon: "lucideSend",
                permissions: [PERMISSION.CRDREQ_HEADOFFICE_REQUEST_TO_SWITCH],
                routerLink: [APP_ROUTES.ROOT, APP_ROUTES.PREPAID],
              },
              {
                label: "Assign Branch",
                icon: "lucideShare2",
                permissions: [PERMISSION.PREPAID_BRANCH_ASSIGN_PENDING_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.ASSIGN,
                ],
              },
              {
                label: "Card Dispatch",
                icon: "nchlWallet",
                permissions: [PERMISSION.PREPAID_LIST_FOR_CARD_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.DISPATCH,
                ],
              },
              {
                label: "PIN Dispatch",
                icon: "lucideSend",
                permissions: [PERMISSION.PREPAID_LIST_FOR_PIN_DISPATCH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.PIN_DISPATCH,
                ],
              },
              {
                label: "Card Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.PREPAID_LIST_FOR_CARD_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.CARD_ACKNOWLEDGE,
                ],
              },
              {
                label: "Pin Acknowledge",
                icon: "lucideThumbsUp",
                permissions: [PERMISSION.PREPAID_LIST_FOR_CARD_ACK],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.PIN_ACKNOWLEDGE,
                ],
              },
              {
                label: "Link Card",
                icon: "lucideLink",
                permissions: [PERMISSION.PREPAID_LIST_FOR_LINKING_CARD],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.LINK,
                ],
              },
              {
                label: "Verify Linked Cards",
                icon: "nchlCheck",
                permissions: [PERMISSION.PREPAID_LIST_FOR_LINK_CARD_VERIFY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.VERIFY,
                ],
              },
              {
                label: "Activate Linked Cards",
                icon: "nchlKey",
                permissions: [PERMISSION.PREPAID_LIST_FOR_LINKING_CARD],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.ACTIVATE_LINKED_ACCOUNT,
                ],
              },
              {
                label: "Card Mapping",
                icon: "lucideArrowRightLeft",
                permissions: [PERMISSION.PREPAID_LIST_FOR_CARD_MAPPING],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.CARD_MAPPING,
                ],
              },
              {
                label: "Card Delivery",
                icon: "nchlKey",
                permissions: [PERMISSION.PREPAID_LIST_FOR_CARD_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.CARD_DELIVERY,
                ],
              },
              {
                label: "Pin Delivery",
                icon: "nchlKey",
                permissions: [PERMISSION.PREPAID_LIST_FOR_PIN_DELIVERY],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.PIN_DELIVERY,
                ],
              },
              {
                label: "Activate",
                icon: "nchlCheckCircle",
                permissions: [
                  // PERMISSION.PREPAID_CARD_LINK_ACTIVATE_PENDING_LIST_FOR_CARD_ACTIVATION,
                  PERMISSION.PREPAID_LIST_FOR_CARD_ACTIVATION,
                ],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.ACTIVATE,
                ],
              },
              {
                label:"Load Amount",
                icon:"lucideBadgeDollarSign",
                permissions:[
                  PERMISSION.PREPAID_LOAD_AMOUNT_VIEW,
                ],
                routerLink:[
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.LOAD_AMOUNT,
                ]
              },
              {
                label:"Withdraw Amount",
                icon:"lucideBadgeDollarSign",
                permissions:[
                  PERMISSION.PREPAID_WITHDRAW_AMOUNT_VIEW
                ],
                routerLink:[
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PREPAID,
                  APP_ROUTES.PREPAID_CARDS.WITHDRAW_AMOUNT,

                ]

              }
              // {
              //   label: "Report",
              //   icon: "lucideChartBar",
              //   permissions: [PERMISSION.PREPAID_ALL_CARD_LIST],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.PREPAID,
              //     APP_ROUTES.PREPAID_CARDS.REPORT,
              //   ],
              // },
            ],
          },

          {
            label: "Renew Cards",
            icon: "nchlCalendar",
            permissions: [
              // PERMISSION.CARD_EXPIRE_LIST_VIEW,
              PERMISSION.RENEW_VIEW,
            ],
            items: [
              {
                label: "Renewable Cards",
                // label: 'To Be Renew Cards',
                icon: "nchlCalendar",
                permissions: [PERMISSION.RENEW_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.TO_BE_RENEW,
                ],
              },
              {
                // label: 'Renew Cards',
                label: "Process Renewals",
                icon: "nchlCalendar",
                permissions: [PERMISSION.RENEW_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.RENEW,
                ],
              },
            ],
          },
          {
            label: "Replace Cards",
            icon: "nchlCalendar",
            permissions: [PERMISSION.REPLACE_VIEW],
            items: [
              {
                label: "Pending List",
                icon: "lucideClock",
                permissions: [PERMISSION.REPLACE_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.REPLACE,
                ],
              },
            ],
          },
          {
            label: "Destroy Cards",
            icon: "lucideEraser",
            permissions: [
              PERMISSION.CARD_DESTROY_VIEW,
              PERMISSION.CARD_DESTROY_CREATE,
              PERMISSION.CARD_DESTROY_APPROVE_REJECT,
            ],
            items: [
              {
                label: "Destroyable Cards",
                icon: "lucideEraser",
                permissions: [PERMISSION.CARD_DESTROY_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.TO_BE_DESTROY,
                ],
              },
              // This to be removed
              {
                label: "Process Destroyable Cards",
                icon: "lucideEraser",
                permissions: [PERMISSION.CARD_DESTROY_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.DESTROY,
                ],
              },
            ],
          },
          {
            label: "Block / Unblock Cards",
            icon: "lucideBan",
            permissions: [
              PERMISSION.BLKUNBLK_CREATE,
              PERMISSION.BLKUNBLK_VIEW,
              PERMISSION.BLKUNBLK_UPDATE,
            ],
            items: [
              {
                label: "Card Block Pending",
                icon: "lucideBan",
                permissions: [PERMISSION.BLKUNBLK_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.BLOCK,
                ],
              },
              {
                label: "Card Unblock Pending",
                icon: "nchlCheckCircle",
                permissions: [PERMISSION.BLKUNBLK_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.UNBLOCK,
                ],
              },
            ],
          },
          // {
          //   label: "API Request",
          //   icon: "pi pi-server",
          //   permissions: [
          //     PERMISSION.CARD_PENDING_VIEW,
          //     PERMISSION.CARD_RENEW_LIST_VIEW,
          //     PERMISSION.CARD_REPLACE_LIST_VIEW,
          //   ],
          //   items: [
          //     {
          //       label: "New Card",
          //       icon: "pi pi-credit-card",
          //       permissions: [PERMISSION.CARD_PENDING_VIEW],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.API_REQUEST,
          //         // APP_ROUTES.API_REQUEST.NEW_CARD
          //       ],
          //     },
          //     {
          //       label: "Renew Card",
          //       icon: "pi pi-ellipsis-h",
          //       permissions: [PERMISSION.CARD_RENEW_LIST_VIEW],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.API_REQUEST,
          //         APP_ROUTES.API_REQUEST_ITMES.SUPPLEMENTARY_CARD,
          //         // APP_ROUTES.REPORT,
          //       ],
          //     },
          //     {
          //       label: "Replace Card",
          //       icon: "pi pi-copy",
          //       permissions: [PERMISSION.CARD_REPLACE_LIST_VIEW],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.API_REQUEST,
          //         APP_ROUTES.API_REQUEST_ITMES.SUPPLEMENTARY_CARD,
          //         // APP_ROUTES.REPORT,
          //       ],
          //     },
          //   ],
          // },
          // {
          //   label: "Reprocess",
          //   icon: "pi pi-sync",
          //   permissions: [PERMISSION.CARD_REPROCESS_LIST_VIEW],
          //   items: [
          //     {
          //       label: "Pending Cards",
          //       icon: "",
          //       permissions: [PERMISSION.CARD_REPROCESS_LIST_VIEW],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.CARD,
          //         APP_ROUTES.CARD_REPROCESS,
          //       ],
          //     },
          //     {
          //       label: "Switch Failed Cards",
          //       icon: "",
          //       // permissions: [PERMISSION.CARD_REPROCESS_LIST_VIEW],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.CARD,
          //         APP_ROUTES.CARD_REPROCESS,
          //         APP_ROUTES.CARD_REPROCESS_SWITCH,
          //       ],
          //     },
          //       {
          //         label: 'Block / Unblock Request',
          //         icon: 'pi pi-ban',
          //         // permissions: [PERMISSION.SYSTEM_USER_VIEW],
          //         routerLink: [
          //           APP_ROUTES.ROOT,
          //           APP_ROUTES.CARD,
          //           APP_ROUTES.CARD_REPROCESS,
          //           APP_ROUTES.CARD_REPROCESS_BLOCK,
          //         ],
          //       },
          //   ],
          // },
          //for v1
          {
            label: "Pin Management",
            icon: "lucideRefreshCw",
            permissions: [
              // PERMISSION.CARD_REPIN_ACCEPT,
              PERMISSION.REPIN_LIST,
              PERMISSION.REPIN_SEND_TO_SWITCH,
              PERMISSION.REPIN_ACKNOWLEDGE,
              PERMISSION.REPIN_DELIVER,
              // PERMISSION.CARD_REPIN_ACTIVATE, //Backend WIP
            ],
            items: [
              {
                label: "Pin Refresh",
                icon: "lucideRefreshCw",
                permissions: [PERMISSION.PIN_REFRESH],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PIN_REFRESH,
                ],
              },
              {
                label: "Pin Status Change",
                icon: "lucideSettings",
                permissions: [PERMISSION.REPROCESS_PIN_STATUS_CHANGE],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.PIN_STATUS_CHANGE,
                ],
              },
              {
                label: "Repin",
                icon: "",
                permissions: [PERMISSION.REPIN_LIST],
                items: [
                  {
                    label: "Repin Request",
                    icon: "lucideFileText",
                    permissions: [PERMISSION.REPIN_LIST],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      // APP_ROUTES.PIN or APP_ROUTES.REPIN To be confirmed
                      APP_ROUTES.REPIN,
                    ],
                  },

                  {
                    label: "Send to Switch",
                    icon: "lucideSend",
                    permissions: [PERMISSION.REPIN_SEND_TO_SWITCH],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      APP_ROUTES.REPIN,
                      APP_ROUTES.SEND_TO_SWITCH,
                    ],
                  },

                  {
                    label: "Repin Dispatch",
                    icon: "lucideMail",
                    permissions: [PERMISSION.REPIN_DISPATCH],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      APP_ROUTES.REPIN,
                      APP_ROUTES.REPIN_DISPATCH,
                    ],
                  },
                  {
                    label: "Repin Acknowledge",
                    icon: "lucideThumbsUp",
                    permissions: [PERMISSION.REPIN_ACKNOWLEDGE],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      APP_ROUTES.REPIN,
                      APP_ROUTES.REPIN_ACKNOWLEDGE,
                    ],
                  },
                  {
                    label: "Repin Delivery",
                    icon: "lucideUserCheck",
                    permissions: [PERMISSION.REPIN_DELIVER],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      APP_ROUTES.REPIN,
                      APP_ROUTES.REPIN_DELIVERY,
                    ],
                  },
                ]
              },
              // {
              //   label: "Repin",
              //   icon: "",
              //   permissions: [PERMISSION.REPIN_LIST],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     // APP_ROUTES.PIN or APP_ROUTES.REPIN To be confirmed
              //     APP_ROUTES.REPIN,
              //   ],
              // },
              // {
              //   label: "Send to Switch",
              //   icon: "",
              //   permissions: [PERMISSION.REPIN_SEND_TO_SWITCH],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.REPIN,
              //     APP_ROUTES.SEND_TO_SWITCH,
              //   ],
              // },
              // {
              //   label: "Repin Dispatch",
              //   icon: "",
              //   permissions: [PERMISSION.REPIN_DISPATCH],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.REPIN,
              //     APP_ROUTES.REPIN_DISPATCH,
              //   ],
              // },
              // {
              //   label: "Repin Acknowledge",
              //   icon: "",
              //   permissions: [PERMISSION.REPIN_ACKNOWLEDGE],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.REPIN,
              //     APP_ROUTES.REPIN_ACKNOWLEDGE,
              //   ],
              // },
              // {
              //   label: "Repin Delivery",
              //   icon: "",
              //   permissions: [PERMISSION.REPIN_DELIVER],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.REPIN,
              //     APP_ROUTES.REPIN_DELIVERY,
              //   ],
              // },


              // {
              //   label: "Repin Activation",
              //   icon: "",
              //   permissions: [PERMISSION.CARD_REPIN_ACTIVATE],
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.REPIN,
              //     APP_ROUTES.REPIN_ACTIVATION,
              //   ],
              // },
            ],
          },

          /*      {
                  label: 'Delivery',
                  icon: 'pi pi-calendar-minus',
                  items: [
                    {
                      label: 'List',
                      icon: '',
                      permissions: [PERMISSION.SYSTEM_USER_VIEW],
                      routerLink: [
                        APP_ROUTES.ROOT,
                        APP_ROUTES.PIN,
                        APP_ROUTES.SYSTEM_USER,
                      ],
                    }
                  ]

                },*/

          {
            label: "Card Migration",
            icon: "lucideArrowRightLeft",
            permissions: [PERMISSION.MGRT_VIEW, PERMISSION.MGRT_MIGRATE],
            items: [
              {
                label: "Migration List",
                icon: "lucideArrowRightLeft",
                permissions: [
                  PERMISSION.MGRT_VIEW,
                  // PERMISSION.CARD_MIGRATE_APPROVE,
                ],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD,
                  APP_ROUTES.MIGRATE,
                ],
              },
            ],
          },
          // {
          //   label: "Report",
          //   icon: "lucideChartBar",
          //   permissions: [
          //     // PERMISSION.CARD_LIST_VIEW
          //   ],
          //   items: [
          //     {
          //       label: "Cards",
          //       icon: "",
          //       permissions: [
          //         // PERMISSION.CARD_LIST_VIEW
          //       ],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.CARD,
          //         APP_ROUTES.REPORTS,
          //       ],
          //     },
          //     {
          //       label: "Customer Charges",
          //       icon: "",
          //       // permissions: [PERMISSION.CARD_LIST_VIEW],
          //       routerLink: [
          //         APP_ROUTES.ROOT,
          //         APP_ROUTES.REPORTS,
          //         APP_ROUTES.CUST_CHARGE,
          //       ],
          //     },
          //   ],
          // },
          {
            label: "Card Order",
            icon: "lucideCreditCard",
            permissions: [
              PERMISSION.CRDREQ_CREATE,
              PERMISSION.CRDREQ_VIEW,
              PERMISSION.CRDREQ_APPROVE,
              PERMISSION.CRDREQ_DELIVER,
              // PERMISSION.CRDREQ_HEADOFFICE_REQUEST_TO_SWITCH,
            ],
            items: [
              {
                label: "Request Cards",
                icon: "lucideFileInput",
                permissions: [
                  PERMISSION.CRDREQ_CREATE,
                  PERMISSION.CRDREQ_VIEW,
                  PERMISSION.CRDREQ_APPROVE,
                ],
                routerLink: [APP_ROUTES.ROOT, "cards-order"],
              },
              // {
              //   label: "Approve Order",
              //   icon: "",
              //   routerLink: [
              //     APP_ROUTES.ROOT,
              //     APP_ROUTES.REPORTS,
              //     APP_ROUTES.CUST_CHARGE,
              //   ],
              // },
            ],
          },
        ],
      },
      {
        label: "Reprocess",
        permissions: [PERMISSION.REPROCESS_CHARGE_VIEW, PERMISSION.REPROCESS_DESTROY_VIEW, PERMISSION.REPROCESS_BLOCK_VIEW,
              PERMISSION.REPROCESS_UNBLOCK_VIEW ],
        items: [
          {
            label: "Customer Charges",
            icon: "lucideBadgeDollarSign",
            permissions: [PERMISSION.REPROCESS_CHARGE_VIEW],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.CARD_REPROCESS,
              APP_ROUTES.CUST_CHARGE,
            ],
          },
          {
            label: "Destroyable Cards",
            icon: "lucideEraser",
            permissions: [PERMISSION.REPROCESS_DESTROY_VIEW],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.CARD_REPROCESS,
              APP_ROUTES.DESTROY,
            ],
          },
            {
            label: "Block / Unblock Cards",
            icon: "lucideBan",
            permissions: [
              PERMISSION.REPROCESS_BLOCK_VIEW,
              PERMISSION.REPROCESS_UNBLOCK_VIEW
            ],
            items: [
              {
                label: "Card Block ",
                icon: "lucideBan",
                permissions: [PERMISSION.REPROCESS_BLOCK_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                   APP_ROUTES.CARD_REPROCESS,
                  APP_ROUTES.REPROCESS_CARD_BLOCK,
                ],
              },
              {
                label: "Card Unblock",
                icon: "nchlCheckCircle",
                permissions: [PERMISSION.REPROCESS_UNBLOCK_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD_REPROCESS,
                  APP_ROUTES.REPROCESS_CARD_UNBLOCK,
                ],
              },
            ],
          },
          // {
          //   label: "Block Cards",
          //   icon: "lucideBan",
          //   // permissions: [PERMISSION.CARD_BLOCK_LIST_VIEW],
          //   routerLink: [
          //     APP_ROUTES.ROOT,
          //     APP_ROUTES.CARD_REPROCESS,
          //     APP_ROUTES.BLOCK_UNBLOCK,
          //   ],
          // },

          {
            label: "Load Amount",
            icon: "lucideBadgeDollarSign",
            permissions: [PERMISSION.REPROCESS_LOAD_AMOUNT_VIEW],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.CARD_REPROCESS,
              APP_ROUTES.REPROCESS_LOAD_AMOUNT,
            ],
          },

          {
                label: "Withdraw Amount",
                icon: "lucideBadgeDollarSign",
                permissions: [PERMISSION.REPROCESS_WITHDRAW_AMOUNT_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD_REPROCESS,
                  APP_ROUTES.REPROCESS_WITHDRAW_AMOUNT,
                ],
              },
          {
            label: "Pin Reprocess",
            icon: "lucideEraser",
            permissions: [PERMISSION.REPROCESS_PIN_REFRESH_VIEW,PERMISSION.REPROCESS_PIN_CHANGE_VIEW],
            items:[
              {
                label:'Pin Refresh',
                icon:"lucideRefreshCw",
            permissions: [PERMISSION.REPROCESS_PIN_REFRESH_VIEW],
                routerLink:[
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD_REPROCESS,
                  APP_ROUTES.REPIN
                ]

              },
              {
                label:"Pin Status Change",
                icon:"lucideSettings",
                 permissions: [PERMISSION.REPROCESS_PIN_CHANGE_VIEW],
                routerLink:[
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD_REPROCESS,
                  APP_ROUTES.PIN_STATUS_CHANGE
                ]

              }, 
              

            ],

            // routerLink: [
            //   APP_ROUTES.ROOT,
            //   APP_ROUTES.CARD_REPROCESS,
            //   APP_ROUTES.REPIN,
            // ],
          },
          {
            label: "Credit Card Service Mapping",
            icon: "lucideEraser",
            permissions: [PERMISSION.REPROCESS_SERVICE_TYPE_UPDATE_VIEW],
            routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CARD_REPROCESS,
                  APP_ROUTES.CCARD_REPORT
                ],
          },
        ],
      },
      {
        label: "Report",
        permissions: [
          PERMISSION.CARD_REPORT, 
          PERMISSION.SWITCH_FILE_REPORT,
          PERMISSION.LETTER_REPORT, 
          PERMISSION.REPORT_CARDDESTROY,
          PERMISSION.PIN_REPORT,
          PERMISSION.REPORT_BLKUNBLK,
          PERMISSION.PREPAID_CARD_REPORT,
          PERMISSION.CHARGE_ENTRY_VIEW
        ],
        items: [
          {
            label: "Cards",
            icon: "lucideFileText",
            permissions: [PERMISSION.CARD_REPORT],
            routerLink: [APP_ROUTES.ROOT, APP_ROUTES.CARD, APP_ROUTES.REPORTS],
          },
          {
            label: "Switch File Details",
            icon: "lucideFileText",
            permissions: [PERMISSION.SWITCH_FILE_REPORT],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.SWITCH_FILE,
            ],
          },
          {
            label: "Customer Charge",
            icon: "lucideBadgeDollarSign",
            permissions: [PERMISSION.CHARGE_ENTRY_VIEW],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.CUST_CHARGE,
            ],
          },
          {
            label: "Letter Report",
            icon: "lucideFileText",
            permissions: [PERMISSION.LETTER_REPORT],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.LETTER_REPORT,
            ],
          },
          {
            label: "Card Destruction Report",
            icon: "lucideFileText",
           permissions: [PERMISSION.REPORT_CARDDESTROY],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.CARD_DESTROYAL_REPORT,
            ],
          },
          {
            label: "Pin Repin Report",
            icon: "lucideFileText",
            permissions: [PERMISSION.PIN_REPORT],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.CARD_PIN_REPIN_REPORT,
            ],
          },
          {
            label: "Block/Unblock Report",
            icon: "lucideFileText",
            permissions: [PERMISSION.REPORT_BLKUNBLK],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.BLOCK_UNBLOCK,
            ],
          },
          {
            label: "Prepaid Card Report",
            icon: "lucideFileText",
            permissions: [PERMISSION.PREPAID_CARD_REPORT],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.PREPAID_CARD_REPORT,]
          },
          {
            label: "Instant Card Report",
            icon: "lucideFileText",
            permissions: [PERMISSION.INSTANT_CARD_REPORT],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.INSTANT_CARD_REPORT
            ]
          },
          {
            label: "Transaction Report",
            icon: "lucideFileText",
            permissions:[PERMISSION.PREPAID_TRANSACTION_REPORT,
            ],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.TRANSACTION_REPORT,
              APP_ROUTES.LOAD
            ],
          },
          {
            label: "Waiver History Report",
            icon: "lucideFileText",
            permissions:[PERMISSION.WAIVER_HISTORY_REPORT],
            routerLink: [
              APP_ROUTES.ROOT,
              APP_ROUTES.REPORTS,
              APP_ROUTES.WAIVER_HISTORY_REPORT
            ]
          }
          
        ],
      },
      {
        label: "Setting",
        permissions: [
          PERMISSION.USR_LIST,
          PERMISSION.ROLE_LIST,
          PERMISSION.PERMISSION_LIST,
        ],
        items: [
          {
            label: "Admin",
            icon: "lucideShield",
            permissions: [
              PERMISSION.USR_LIST,
              PERMISSION.ROLE_LIST,
              PERMISSION.PERMISSION_LIST,
            ],
            items: [
              {
                label: "Users",
                icon: "lucideUserCheck",
                permissions: [PERMISSION.USR_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.ADMIN,
                  APP_ROUTES.SYSTEM_USER,
                ],
                /*items: [
                  {
                    label: 'List',
                    icon: '',
                    permissions: [PERMISSION.SYSTEM_USER_PAGE],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      APP_ROUTES.ADMIN,
                      APP_ROUTES.SYSTEM_USER
                    ],
                  }
                ]*/
              },
              {
                label: "Roles",
                icon: "lucideShield",
                permissions: [PERMISSION.ROLE_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.ADMIN,
                  APP_ROUTES.ROLES,
                ],
                /*items: [
                  {
                    label: 'List',
                    icon: '',
                    // permissions: [PERMISSION.SYSTEM_USER_VIEW],
                    routerLink: [
                      APP_ROUTES.ROOT,
                      APP_ROUTES.ADMIN,
                      APP_ROUTES.ROLES,
                    ],
                  }
                ]*/
              },
              {
                label: "Permissions",
                icon: "nchlKey",
                permissions: [PERMISSION.PERMISSION_LIST],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.ADMIN,
                  APP_ROUTES.PERMISSIONS,
                ],
              },
            ],
          },
          {
            label: "Profile Update",
            icon: "lucideUser",
            permissions: [
              PERMISSION.CUSTOMER_INFO_UPDATE_VIEW, PERMISSION.VIEW_SERVICE_TYPE_UPDATE
            ],
            items: [
              {
                label: "Customer Details",
                icon: "lucideUserPen",
                permissions: [PERMISSION.CUSTOMER_INFO_UPDATE_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CUSTOMERS,
                ],
              },
              {
                label: "Credit Card Service Mapping",
                icon: "lucideUserPen",
                permissions: [PERMISSION.VIEW_SERVICE_TYPE_UPDATE],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.CUSTOMERS,
                  APP_ROUTES.CREDIT_CARD_SERVICE_MAPPING,
                ],
              },
            ],
          },
          {
            label: "Data Migrate",
            icon: "lucideFileText",
            permissions: [
              PERMISSION.DATA_MGN01,
              PERMISSION.DATA_MGN02,
              PERMISSION.DATA_MGN03
            ],
            items: [
              {
                label: "Migrate ",
                icon: "lucideFileText",
                // permissions: [PERMISSION.CUSTOMER_INFO_UPDATE_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.MIGRATE,
                ],
              },
            ],
          },
          {
            label: "Direct EFT Card Block",
            icon: "lucideBan",
            permissions: [
              PERMISSION.DIRECT_BLOCK_VIEW
            ],
            items: [
              {
                label: "Card Block",
                icon: "lucideBan",
                permissions: [PERMISSION.DIRECT_BLOCK_VIEW],
                routerLink: [
                  APP_ROUTES.ROOT,
                  APP_ROUTES.DIRECT_CARD_BLOCK,
                ],
              },
            ],
          },
        ],
      
      },
    ];
  }

  getPermittedMenuItems(menuItems: VerticalMenuItem[]) {
    return menuItems.filter((d) => {
      if (Array.isArray(d.items)) {
        // Todo: avoid mutation
        d.items = this.getPermittedMenuItems(d.items);
      }

      if (Array.isArray(d.permissions)) {
        return this.permissionService.hasPermission(d.permissions);
      } else {
        return true;
      }
    });
  }
}
